<template>
<box-view class="home container-fluid px-0 mb-0 font-weight-bold " title="Bán Hàng"  :showBack="false" @close="close">
    

    <!-- Search -->
    <div class="bg-white py-2 border-bottom">
        <div class="container">
            <van-search v-model="searchQuery" placeholder="Tìm kiếm sản phẩm" class="search-input" input-align="center" shape="round" background="#4fc08d" />
        </div>
    </div>

    <!-- Main Area -->
    <div class="container-fluid py-3">
        <div class="row">
            <!-- Product Grid -->
            <div class="col-12 col-md-7 mb-4 mb-md-0">
                <div class="row mx-n2">
                    <div v-for="product in filteredProducts" :key="product.id" class="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-2 mb-3 px-2">
                        <div class="card h-100 product-card shadow-sm" @click="addToCart(product)" style="cursor:pointer">
                            <img :src="product.image || ''" class="card-img-top product-img mx-auto d-block" :alt="product.name" style="object-fit:cover;height:80px;max-width:100%;" @error="imgError" />
                            <div class="card-body p-2 d-flex flex-column">
                                <div class="font-weight-bold mb-1" style="font-size: 0.85rem; line-height: 1.2;">{{ product.name }}</div>
                                <div class="text-secondary small mb-1" style="font-size: 0.75rem;">({{ product.unit }})</div>
                                <div class="mt-auto">
                                    <div class="text-danger font-weight-bold mb-1" style="font-size: 0.9rem;">{{ product.price | formatCurrency }}</div>
                                    <div class="text-muted" style="font-size: 0.7rem;">Mã: {{ product.code }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="filteredProducts.length === 0" class="col-12 text-center text-muted py-5">
                        Không tìm thấy sản phẩm.
                    </div>
                </div>
            </div>

            <!-- Cart Panel -->
            <div class="col-12 col-md-5 d-none d-md-block">
                <div class="card shadow-sm cart-panel">
                    <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                        <h5 class="mb-0 font-weight-bold">Giỏ hàng</h5>
                        <span v-if="customer.name" class="badge badge-success">{{ customer.name }}</span>
                    </div>
                    <!-- Customer Search (trong cart panel) -->
                    <div class="p-2 border-bottom bg-light">
                        <div class="position-relative">
                            <van-field 
                                v-model="customerSearchQuery" 
                                left-icon="search" 
                                placeholder="Tìm khách hàng (Tên/SĐT)..." 
                                class="border rounded" 
                                :border="false"
                                @input="onSearchCustomer"
                                clearable
                                size="small"
                            />
                            <!-- Suggestions Dropdown -->
                            <div v-if="customerSuggestions.length > 0" class="position-absolute w-100 bg-white shadow rounded border" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
                                <div 
                                    v-for="cus in customerSuggestions" 
                                    :key="cus.id" 
                                    class="p-2 border-bottom cursor-pointer hover-bg-light d-flex justify-content-between align-items-center"
                                    @click="selectCustomer(cus)"
                                    style="cursor: pointer;"
                                >
                                    <div class="flex-grow-1 pr-2">
                                        <div class="font-weight-bold text-primary">{{ cus.name }}</div>
                                        <div class="small text-muted">{{ cus.phone }} <span v-if="cus.address">- {{ cus.address }}</span></div>
                                    </div>
                                    <div class="text-right flex-shrink-0">
                                        <span v-if="(cus.debtAmount !== undefined ? cus.debtAmount : cus.debt_amount) > 0" class="small text-danger font-weight-bold">
                                            Nợ: {{ (cus.debtAmount !== undefined ? cus.debtAmount : cus.debt_amount) | formatCurrency }}
                                        </span>
                                        <span v-else-if="(cus.debtAmount !== undefined ? cus.debtAmount : cus.debt_amount) < 0" class="small text-success font-weight-bold">
                                            Cọc: {{ Math.abs(cus.debtAmount !== undefined ? cus.debtAmount : cus.debt_amount) | formatCurrency }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Selected Customer Info -->
                        <div v-if="selectedCustomerId" class="mt-1 d-flex align-items-center justify-content-between">
                            <small class="text-success"><i class="van-icon van-icon-manager-o mr-1"></i>{{ customer.name }} - {{ customer.phone }}</small>
                            <small class="text-primary cursor-pointer" @click="clearSelectedCustomer" style="cursor:pointer">✕ Bỏ chọn</small>
                        </div>
                    </div>
                    <div class="card-body p-2 cart-body-scroll">
                        <div v-if="cart.length === 0" class="text-center text-muted py-4">
                            Chưa có sản phẩm nào.
                        </div>
                        <div v-else>
                            <div v-for="item in cart" :key="item.product.id" class="cart-item d-flex align-items-center border-bottom py-2">
                                <div class="flex-grow-1">
                                    <div class="font-weight-bold ">{{ item.product.name }}
                                        <span class="text-secondary small">({{ item.product.unit }})</span>
                                    </div>
                                    <div class="text-muted small">Mã: {{ item.product.code }}</div>
                                </div>
                                <div class="cart-stepper mx-2">
                                    <formatted-stepper v-model="item.quantity" :min="1" @change="updateQuantity(item, item.quantity)" />
                                </div>
                                <div class="cart-price-input mx-2">
                                    <money-input class="form-control form-control-sm" v-model="item.price" @change="updatePrice(item, item.price)" :placeholder="item.product.price" :readonly="!canEditPrice" :class="{'bg-light': !canEditPrice}" />
                                    <div v-if="getHistoryPrice(item.product.id) !== null && item.price !== getHistoryPrice(item.product.id)"
                                         class="text-info small mt-1" 
                                         style="cursor:pointer; white-space:nowrap;" 
                                         @click="item.price = getHistoryPrice(item.product.id)">
                                        ↩ Giá cũ: {{ getHistoryPrice(item.product.id) | formatCurrency }}
                                    </div>
                                </div>
                                <div class="cart-total text-right font-weight-bold">
                                    {{ (item.price * item.quantity) | formatCurrency }}
                                </div>
                                <van-button icon="delete" size="mini" type="danger" class="ml-2" @click="removeFromCart(item)" />
                            </div>
                        </div>
                    </div>
                    <div class="card-footer bg-white d-flex justify-content-between align-items-center">
                        <span class="font-weight-bold">Tổng cộng</span>
                        <span class="h5 mb-0 text-danger">{{ cartTotal | formatCurrency }}</span>
                    </div>
                    <van-button type="primary" block @click="showOrderDialog = true" :disabled="!canCreateOrder || cart.length === 0">Tạo đơn</van-button>
                </div>
            </div>
        </div>
    </div>

    <!-- Fixed Checkout Button (Mobile Only) -->
    <van-button class="fixed-footer mobile-only" type="danger" block size="large" :disabled="cart.length === 0" @click="showCartPopup = true">
        Xem giỏ hàng ({{ cartCount }})
    </van-button>

    <!-- Popup giỏ hàng cho mobile -->
    <van-popup v-model="showCartPopup" position="bottom" :style="{ height: '80%' }" class="cart-popup">
        <div class="cart-popup-header">
            <span>Giỏ hàng</span>
            <van-icon name="close" @click="showCartPopup = false" />
        </div>
        <!-- Customer Search (Mobile) -->
        <div class="p-2 border-bottom bg-light">
            <div class="position-relative">
                <van-field 
                    v-model="customerSearchQuery" 
                    left-icon="search" 
                    placeholder="Tìm khách hàng (Tên/SĐT)..." 
                    class="border rounded" 
                    :border="false"
                    @input="onSearchCustomer"
                    clearable
                    size="small"
                />
                <div v-if="customerSuggestions.length > 0" class="position-absolute w-100 bg-white shadow rounded border" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
                    <div 
                        v-for="cus in customerSuggestions" 
                        :key="cus.id" 
                        class="p-2 border-bottom d-flex justify-content-between align-items-center"
                        @click="selectCustomer(cus)"
                        style="cursor: pointer;"
                    >
                        <div class="flex-grow-1 pr-2">
                            <div class="font-weight-bold text-primary">{{ cus.name }}</div>
                            <div class="small text-muted">{{ cus.phone }}</div>
                        </div>
                        <div class="text-right flex-shrink-0">
                            <span v-if="(cus.debtAmount !== undefined ? cus.debtAmount : cus.debt_amount) > 0" class="small text-danger font-weight-bold">
                                Nợ: {{ (cus.debtAmount !== undefined ? cus.debtAmount : cus.debt_amount) | formatCurrency }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="selectedCustomerId" class="mt-1 d-flex align-items-center justify-content-between">
                <small class="text-success"><i class="van-icon van-icon-manager-o mr-1"></i>{{ customer.name }} - {{ customer.phone }}</small>
                <small class="text-primary" @click="clearSelectedCustomer" style="cursor:pointer">✕ Bỏ chọn</small>
            </div>
        </div>
        <div class="cart-popup-body">
            <!-- Hiển thị danh sách sản phẩm trong giỏ hàng -->
            <div class="card-body p-2">
                <div v-if="cart.length === 0" class="text-center text-muted py-4">
                    Chưa có sản phẩm nào.
                </div>
                <div v-else>
                    <div v-for="item in cart" :key="item.product.id" class="cart-item d-flex align-items-center border-bottom py-2">
                        <div class="flex-grow-1">
                            <div class="font-weight-bold ">{{ item.product.name }}
                                <span class="text-secondary small">({{ item.product.unit }})</span>
                            </div>
                            <div class="text-muted small">Mã: {{ item.product.code }}</div>
                        </div>
                        <div class="cart-stepper mx-2">
                            <formatted-stepper v-model="item.quantity" :min="1" @change="updateQuantity(item, item.quantity)" />
                        </div>
                        <div class="cart-price-input mx-2">
                            <money-input class="form-control form-control-sm" v-model="item.price" @change="updatePrice(item, item.price)" :placeholder="item.product.price" :readonly="!canEditPrice" :class="{'bg-light': !canEditPrice}" />
                            <div v-if="getHistoryPrice(item.product.id) !== null && item.price !== getHistoryPrice(item.product.id)"
                                 class="text-info small mt-1" 
                                 style="cursor:pointer; white-space:nowrap;" 
                                 @click="item.price = getHistoryPrice(item.product.id)">
                                ↩ Giá cũ: {{ getHistoryPrice(item.product.id) | formatCurrency }}
                            </div>
                        </div>
                        <div class="cart-total text-right font-weight-bold">
                            ₫{{ (item.price * item.quantity).toLocaleString() }}
                        </div>
                        <van-button icon="delete" size="mini" type="danger" class="ml-2" @click="removeFromCart(item)" />
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white d-flex justify-content-between align-items-center">
            <span class="font-weight-bold">Tổng cộng</span>
            <span class="h5 mb-0 text-danger">{{ cartTotal | formatCurrency }}</span>
        </div>
        <van-button type="primary" block @click="showOrderDialog = true" :disabled="!canCreateOrder || cart.length === 0">Tạo đơn</van-button>
    </van-popup>
    <!-- Popup nhỏ gọn -->
    <van-dialog class="showOrder" v-model="showOrderDialog" title="Xác nhận đơn hàng" show-cancel-button confirm-button-text="Xuất đơn ngay" cancel-button-text="Đóng" :before-close="onBeforeCloseDialog" width="600px">
        <div class="order-dialog-content">
            <!-- Payment Section -->
            <div class="dialog-section mb-3">
                <div class="section-title text-primary font-weight-bold mb-2"> <i class="van-icon van-icon-bill-o mr-1"></i>Thanh toán</div>
                <div class="bg-light rounded p-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="text-muted">Tổng tiền hàng:</span>
                        <span class="font-weight-bold h6 mb-0">{{ totalAmount | formatCurrency }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="text-muted">Giảm giá:</span>
                        <div style="width: 150px">
                             <money-input v-model="discount" placeholder="0" class="form-control text-right border-0 p-0" style="background: transparent;" />
                        </div>
                    </div>
                    <hr class="my-2">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="text-dark font-weight-bold">Khách phải trả:</span>
                        <span class="text-danger h5 mb-0 font-weight-bold">{{ totalAmountCart | formatCurrency }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-muted mr-2" style="white-space: nowrap;">💵 Tiền mặt:</span>
                        <div class="d-flex align-items-center justify-content-end flex-grow-1">
                             <van-button size="mini" type="primary" class="mr-2" @click="cashAmount = totalAmountCart; transferAmount = 0">Đủ</van-button>
                             <div class="input-group input-group-sm" style="width: 140px;">
                                <money-input class="form-control text-right" v-model="cashAmount" placeholder="0" />
                             </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-2">
                        <span class="text-muted mr-2" style="white-space: nowrap;">🏦 Chuyển khoản:</span>
                        <div class="d-flex align-items-center justify-content-end flex-grow-1">
                             <van-button size="mini" type="info" class="mr-2" @click="transferAmount = totalAmountCart; cashAmount = 0">Đủ</van-button>
                             <div class="input-group input-group-sm" style="width: 140px;">
                                <money-input class="form-control text-right" v-model="transferAmount" placeholder="0" />
                             </div>
                        </div>
                    </div>

                     <div class="d-flex justify-content-between align-items-center mt-2" v-if="customerDebt > 0">
                        <span class="text-danger small">Còn thiếu:</span>
                        <span class="text-danger font-weight-bold">{{ customerDebt | formatCurrency }}</span>
                    </div>
                     <div class="mt-2" v-if="totalPaid > totalAmountCart">
                         <div class="d-flex justify-content-between align-items-center">
                             <span class="text-success small">Tiền thừa:</span>
                             <span class="text-success font-weight-bold">{{ (totalPaid - totalAmountCart) | formatCurrency }}</span>
                         </div>
                         <div class="mt-2 pl-1 d-flex align-items-start">
                             <input type="checkbox" id="depositCb" v-model="convertToDeposit" class="mt-1 mr-2" style="width: 16px; height: 16px; cursor: pointer;">
                             <label for="depositCb" class="small text-muted mb-0" style="cursor: pointer; line-height: 1.4;">Chuyển tiền thừa thành Tiền cọc (trừ vào công nợ)</label>
                         </div>
                    </div>
                </div>
            </div>

            <!-- Customer Section -->
            <div class="dialog-section mb-3">
                 <div class="section-title text-success font-weight-bold mb-2"> <i class="van-icon van-icon-manager-o mr-1"></i>Khách hàng</div>
                 <div v-if="selectedCustomerId" class="alert alert-success py-1 px-2 mb-2 small">
                     <strong>{{ customer.name }}</strong> - {{ customer.phone }}
                     <span v-if="customer.debtAmount > 0" class="text-danger ml-2">Nợ: {{ customer.debtAmount | formatCurrency }}</span>
                 </div>
                 <div class="row">
                     <div class="col-6 pr-1">
                          <van-field v-model="customer.name" label="Tên" placeholder="Tên khách" class="border rounded mb-2 pt-1 pb-1" :border="false" />
                     </div>
                     <div class="col-6 pl-1">
                          <van-field v-model="customer.phone" label="SĐT" placeholder="Số điện thoại" class="border rounded mb-2 pt-1 pb-1" :border="false" />
                     </div>
                 </div>
                 <van-field v-model="customer.address" label="Địa chỉ" placeholder="Địa chỉ giao hàng" class="border rounded mb-2 pt-1 pb-1" :border="false" />
                 <van-field v-model="customer.note" label="Ghi chú" placeholder="Ghi chú đơn hàng" rows="1" autosize type="textarea" class="border rounded pt-1 pb-1" :border="false" />
            </div>

             <!-- Actions Section -->
             <div class="dialog-section text-center">
                  <div class="row">
                      <div class="col-6 pr-1">
                          <van-button block size="small" icon="printer" type="info" @click="printBill">In Bill</van-button>
                      </div>
                      <div class="col-6 pl-1">
                          <van-button block size="small" icon="orders-o" type="warning" :disabled="cart.length === 0" @click="saveDraft">Lưu nháp</van-button>
                      </div>
                  </div>
            </div>
        </div>
    </van-dialog>
</box-view>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        },
        settings: {
            type: Object,
            default: () => ({})
        },
        customers: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showCartPopup: false,
            showOrderDialog: false,
            showMenu: false,
            discount: 0,
            cashAmount: 0,
            transferAmount: 0,
            searchQuery: '',
            customer: {
                name: '',
                phone: '',
                address: '',
                note: '',
                debtAmount: 0
            },
            cart: [],
            customerSearchQuery: '',
            customerSuggestions: [],
            customerSearchTimer: null,
            customerHistoryPrices: {},
            selectedCustomerId: null,
            convertToDeposit: false,
        };

    },
    computed: {
        // PERMISSIONS
        canEditPrice() {
            const role = this.user.role || 'admin'; 
            // If settings not loaded yet, default to false safety or true? 
            // Admin usually has all, let's look up safe.
            if(role === 'admin') return true; 
            
            const roleConfig = this.settings.user?.roles?.[role];
            return roleConfig?.permissions?.includes('editPrice');
        },
        canCreateOrder() {
            const role = this.user.role || 'admin';
            if(role === 'admin') return true;

            const roleConfig = this.settings.user?.roles?.[role];
            return roleConfig?.permissions?.includes('createOrder');
        },

        filteredProducts() {
            const q = this.searchQuery.trim().toLowerCase();
            if (!q) return this.products;
            return this.products.filter(
                p =>
                p.name.toLowerCase().includes(q) ||
                p.code.toLowerCase().includes(q)
            );

        },
        totalAmount() {
            return this.cartTotal;
        },
        cartTotal() {
            return this.cart.reduce(
                (sum, item) => sum + item.price * item.quantity,
                0
            );
        },
        cartCount() {
            return this.cart.reduce((sum, item) => sum + item.quantity, 0);
        },
        totalDiscount() {
            // Nếu có nhiều loại giảm giá, tính tổng ở đây, còn không thì trả về discount
            return Number(this.discount) || 0;
        },
        customerDebt() {
            return Math.max(0, this.totalAmount - this.totalDiscount - this.totalPaid);
        },
        totalPaid() {
            return (Number(this.cashAmount) || 0) + (Number(this.transferAmount) || 0);
        },
        totalAmountCart() {
            return (this.totalAmount - this.totalDiscount);

        },
        computedPaymentMethod() {
            const cash = Number(this.cashAmount) || 0;
            const transfer = Number(this.transferAmount) || 0;
            if (cash > 0 && transfer > 0) return 'mixed';
            if (transfer > 0) return 'transfer';
            return 'cash';
        },
        paymentMethodLabel() {
            const m = this.computedPaymentMethod;
            if (m === 'mixed') return 'Tiền mặt + Chuyển khoản';
            if (m === 'transfer') return 'Chuyển khoản';
            return 'Tiền mặt';
        },
        currentOrder() {
            if (!this.cart || this.cart.length === 0) return null;

            return {
                id: 'DH-' + Date.now(),
                createdAt: new Date().toISOString(),
                cart: JSON.parse(JSON.stringify(this.cart)),
                note: this.customer.note,
                customer: {
                    ...this.customer,
                    note: this.customer.note
                        ? `${this.customer.note} - Thanh toán ${this.paymentMethodLabel}`
                        : `Thanh toán ${this.paymentMethodLabel}`,
                    debtAmount: this.customer.debtAmount || 0
                },
                discount: this.discount,
                paid: this.totalPaid,
                cashAmount: Number(this.cashAmount) || 0,
                transferAmount: Number(this.transferAmount) || 0,
                totalAmount: this.totalAmount, // Giá trị trước KM
                totalBill: this.totalAmountCart, // Giá trị sau KM
                totalCost: this.cart.reduce((s, i) => s + (i.cost || i.product.costPrice || 0) * i.quantity, 0),
                debt: this.customerDebt,
                paymentMethod: this.computedPaymentMethod,
                userId: this.user.id,
                convertToDeposit: this.convertToDeposit // Add this for draft prints
            };
        }

    },
    methods: {
        onSearchCustomer(val) {
             if (this.customerSearchTimer) clearTimeout(this.customerSearchTimer);
             if (!val) {
                 this.customerSuggestions = [];
                 return;
             }
             
             this.customerSearchTimer = setTimeout(async () => {
                 try {
                     const res = await this.$root.api.get('/logach/getLoGachCustomers', {
                         params: { key: val, per: 5 }
                     });
                     if (res.data && (res.data.code === 200 || res.data.status === 'OK')) {
                         this.customerSuggestions = res.data.list || (res.data.data && res.data.data.list) || [];
                     }
                 } catch (e) {
                     console.error(e);
                 }
             }, 300);
        },
        selectCustomer(cus) {
            // Find existing customer to get current debt
            const existing = this.customers.find(c => c.id === cus.id);
            const debtAmount = existing ? existing.debtAmount : (cus.debtAmount !== undefined ? cus.debtAmount : (cus.debt_amount || 0));

            this.customer = {
                id: cus.id,
                name: cus.name,
                phone: cus.phone,
                address: cus.address,
                note: cus.note || '',
                debtAmount: debtAmount
            };
            this.selectedCustomerId = cus.id;
            this.customerSearchQuery = '';
            this.customerSuggestions = [];
            this.$toast?.success('Đã chọn khách hàng: ' + cus.name);

            // Fetch lịch sử giá bán của khách hàng này
            this.fetchCustomerPriceHistory(cus.id);
        },
        imgError(e) {
            e.target.onerror = null; 
            e.target.src = '';
        },
        addToCart(product) {
            // Check settings
            const allowNegative = this.settings?.sales?.allowNegativeStock ?? false; 
            const lowStockAlert = this.settings?.inventory?.lowStockAlert ?? false;
            const lowStockThreshold = this.settings?.inventory?.lowStockThreshold || 10;

            const existingItem = this.cart.find(item => item.product.id === product.id);
            const currentQty = existingItem ? existingItem.quantity : 0;
            
            // Check Negative Stock
            if (!allowNegative && (product.stock - currentQty - 1 < 0)) {
                this.$toast.fail(`Sản phẩm "${product.name}" không đủ tồn kho (Còn: ${product.stock})`);
                return;
            }

            // Check Low Stock Alert
            if (lowStockAlert && (product.stock - currentQty - 1 <= lowStockThreshold)) {
                 this.$toast('Sắp hết hàng: ' + product.name);
            }

            if (existingItem) {
                existingItem.quantity++;
            } else {
                // Kiểm tra giá lịch sử của khách hàng đang chọn
                const historyPrice = this.getHistoryPrice(product.id);
                const usePrice = historyPrice !== null ? historyPrice : product.price;

                this.cart.push({
                    product: product,
                    quantity: 1,
                    price: usePrice,
                    cost: product.costPrice || 0
                });

                // Hiển thị thông báo nếu áp dụng giá cũ
                if (historyPrice !== null && historyPrice !== product.price) {
                    this.$toast?.success(`Đã áp giá cũ: ${historyPrice.toLocaleString()}đ`);
                }
            }
        },
        removeFromCart(item) {
            this.cart = this.cart.filter(i => i.product.id !== item.product.id);
        },
        updateQuantity(item, qty) {
            if (qty < 1) item.quantity = 1;
        },
        updatePrice(item, price) {
            if (price < 0) item.price = 0;
        },
        getHistoryPrice(productId) {
            const h = this.customerHistoryPrices[productId];
            return h ? h.price : null;
        },
        async fetchCustomerPriceHistory(customerId) {
            try {
                const res = await this.$root.api.get('/logach/getCustomerPriceHistory', {
                    params: { customer_id: customerId }
                });
                if (res.data && (res.data.code === 200 || res.data.status === 'OK')) {
                    this.customerHistoryPrices = res.data.prices || {};
                    // Áp dụng giá lịch sử cho các item đã có trong giỏ hàng
                    this.applyHistoryPricesToCart();
                }
            } catch (e) {
                console.error('Fetch price history error:', e);
            }
        },
        applyHistoryPricesToCart() {
            let applied = 0;
            this.cart.forEach(item => {
                const hp = this.getHistoryPrice(item.product.id);
                if (hp !== null) {
                    item.price = hp;
                    applied++;
                }
            });
            if (applied > 0) {
                this.$toast?.success(`Đã cập nhật giá cũ cho ${applied} sản phẩm`);
            }
        },
        clearSelectedCustomer() {
            this.selectedCustomerId = null;
            this.customerHistoryPrices = {};
            this.customer = { name: '', phone: '', address: '', note: '', debtAmount: 0 };
            // Reset giá về giá gốc cho tất cả item trong giỏ
            this.cart.forEach(item => {
                item.price = item.product.price;
            });
        },
        printBill() {
            if (!this.currentOrder) {
                this.$toast?.('Giỏ hàng trống');
                return;
            }
            this.$emit('print-bill', { order: this.currentOrder, printType: 'invoice', isNewOrder: true, isDraft: true });
        },
        onBeforeCloseDialog(action, done) {
            if (action === 'confirm') {
                const success = this.exportOrder();
                if (success) {
                    done();
                } else {
                    done(false); // keep dialog open
                }
            } else {
                this.showOrderDialog = false;
                done();
            }
        },
        exportOrder() {
            if (this.cart.length === 0) {
                this.$toast?.('Giỏ hàng trống');
                return false;
            }

            // --- Settings Validation ---
            const requireCustomer = this.settings?.sales?.requireCustomer ?? false;
            const requirePhone = this.settings?.customer?.requirePhoneOnOrder ?? false;

            // 1. Check Require Customer
            // If requireCustomer is true, we need at least a name or phone to identify a customer
            // But wait, if they are "Walk-in", name might be empty?
            // Usually "Require Customer" means you must pick a profile.
            if (requireCustomer) {
                if (!this.customer.name && !this.customer.phone) {
                    this.$toast.fail('Cấu hình yêu cầu bắt buộc chọn thông tin khách hàng.');
                    return false;
                }
            }

            // 2. Check Require Phone
            if (requirePhone) {
                 if (!this.customer.phone || this.customer.phone.trim() === '') {
                    this.$toast.fail('Cấu hình yêu cầu bắt buộc nhập Số điện thoại khách hàng.');
                    return false;
                }
            }

            // 3. Check Allow Debt
            const allowDebt = this.settings?.sales?.allowDebt ?? true;
            const total = this.currentOrder.totalBill || 0;
            const paid = Number(this.currentOrder.paid || 0);
            const remaining = total - paid;
            
            if (!allowDebt && remaining > 0) {
                this.$toast.fail('Cấu hình không được phép bán nợ. Vui lòng thanh toán đủ.');
                return false;
            }

            // 4. Check Negative Stock (Final Guard)
            const allowNegative = this.settings?.sales?.allowNegativeStock ?? false;
            if (!allowNegative) {
                for (const item of this.cart) {
                    if (item.product.stock - item.quantity < 0) {
                         this.$toast.fail(`Sản phẩm "${item.product.name}" không đủ tồn kho để tạo đơn.`);
                         return false;
                    }
                }
            }
            
            // Emit event to App.vue
            const payload = {
                ...this.currentOrder,
                convertToDeposit: this.convertToDeposit // Send flag to backend
            };
            this.$emit('create-order', payload);
            
            // Clear cart
            this.cart = [];
            this.customer = { name: '', phone: '', address: '', note: '', debtAmount: 0 };
            this.selectedCustomerId = null;
            this.customerHistoryPrices = {};
            this.discount = 0;
            this.cashAmount = 0;
            this.transferAmount = 0;
            this.showOrderDialog = false;
            return true;
        },
        saveDraft() {
            if (this.cart.length === 0) {
                this.$toast?.('Giỏ hàng đang trống');
                return;
            }

            // Fix: Emit event instead of direct local storage write
            // The duplicate customer key in computed property 'currentOrder' was likely also causing issues,
            // but ensuring we pass the object properly via event is safer.
            // Also, we need to make sure we are not referencing `this.currentOrder` if it has issues,
            // but with the fix above it should be fine.
            
            this.$emit('save-draft', this.currentOrder);

            this.showOrderDialog = false;
            this.$router.push({ name: 'temporaryorder' });
        },
        logout() {
            // Xử lý logout
            this.showMenu = false;
            // ...
        },
        close() {
            // Home page doesn't need to go back, but adding for consistency
            this.$router.push('/admin');
        }
    },
    mounted() {
        const restore = localStorage.getItem('restoreOrder');
        if (restore) {
            const order = JSON.parse(restore);
            this.cart = order.cart;
            this.customer = order.customer;
            this.discount = order.discount;
            this.cashAmount = order.cashAmount || 0;
            this.transferAmount = order.transferAmount || 0;
            localStorage.removeItem('restoreOrder');
        }
    }

};
</script>

<style scoped>
.product-card:hover {
    transform: translateY(-2px);
    transition: all 0.2s;
}

/* Mobile Fixed Footer Styles */
.fixed-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    border-radius: 0;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

.cart-popup {
    display: flex;
    flex-direction: column;
}

.cart-popup-header {
    padding: 15px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.1em;
}

.cart-popup-body {
    flex-grow: 1;
    overflow-y: auto;
    background: #f8f9fa;
}

/* Responsive Utilities */
.mobile-only {
    display: none !important;
}

@media (max-width: 768px) {
    .mobile-only {
        display: block !important;
    }
    
    .home {
        padding-bottom: 60px; /* Space for fixed footer */
    }
    
    .product-img {
        height: 120px !important;
    }
}
</style>
